document.addEventListener('DOMContentLoaded', function () {

    /* Experience Section */
    const experienceSection = document.querySelector(".experience-section");

    const carouselContainer = experienceSection.querySelector(".carousel-container");
    const carouselColumns = carouselContainer.querySelectorAll(".column");
    const carouselMainColumns = carouselContainer.querySelectorAll(".main-column");

    const leftArrow = experienceSection.querySelector(".left-arrow");
    const rightArrow = experienceSection.querySelector(".right-arrow");

    const carouselDots = experienceSection.querySelectorAll('.dot');

    let carouselIndex = 0;
    carouselDots[0].classList.add("active");

    scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
    carouselContainer.scrollLeft += scrollAmount * 2;

    leftArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft -= scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex <= 0) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * (carouselColumns.length - 6);
                carouselContainer.style.scrollBehavior = 'smooth'; 
                leftArrow.style.pointerEvents = "unset";
                rightArrow.style.pointerEvents = "unset";

                carouselIndex = carouselMainColumns.length - 1;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex--;
            carouselDots[carouselIndex].classList.add("active");
        }
    });
    rightArrow.addEventListener("click", function() {
        scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
        carouselContainer.scrollLeft += scrollAmount;

        experienceSection.querySelector('.dot.active').classList.remove("active");

        if (carouselIndex >= carouselMainColumns.length - 1) {
            leftArrow.style.pointerEvents = "none";
            rightArrow.style.pointerEvents = "none";
            setTimeout(() => {
                carouselContainer.style.scrollBehavior = 'auto'; 
                carouselContainer.scrollLeft = scrollAmount * 2;
                carouselContainer.style.scrollBehavior = 'smooth'; 
                rightArrow.style.pointerEvents = "unset";
                leftArrow.style.pointerEvents = "unset";

                carouselIndex = 0;
                carouselDots[carouselIndex].classList.add("active");
            }, 400);
        }
        else {
            carouselIndex++;
            carouselDots[carouselIndex].classList.add("active");
        }
    });

    // Dots handler
    for (let i = 0; i < carouselDots.length; i++) {
        carouselDots[i].addEventListener("click", function() {
            experienceSection.querySelector('.dot.active').classList.remove("active");
            this.classList.add("active");

            scrollAmount = carouselContainer.scrollWidth / carouselColumns.length;
            carouselContainer.scrollLeft = scrollAmount * (i + 2);
        });
    }

    /* End Experience Section */

    /* Video Section */
    const videoModal = document.querySelector(".video-modal");
    const videoClose =  videoModal.querySelector(".close");
    const videoBar = videoModal.querySelector(".video-bar");
    const videoBarImages = videoBar.querySelectorAll("img");
    const video = videoModal.querySelector("video");

    const videosContainer = document.querySelector(".videos-container");
    const videoColumns = videosContainer.querySelectorAll(".video-column");

    const videoSrcs = [
        "https://happyfruit.com/cdn/shop/videos/c/vp/74e907d9c48446fc91ca97c97d5e43c5/74e907d9c48446fc91ca97c97d5e43c5.HD-1080p-2.5Mbps-54280829.mp4?v=0",
        "https://happyfruit.com/cdn/shop/videos/c/vp/5a68cea5d1a54aa39f149ba719342d73/5a68cea5d1a54aa39f149ba719342d73.HD-1080p-7.2Mbps-54280847.mp4?v=0",
        "https://happyfruit.com/cdn/shop/videos/c/vp/96410fd443184fc1b9e404ab86233847/96410fd443184fc1b9e404ab86233847.HD-1080p-4.8Mbps-54280848.mp4?v=0"
    ];
    
    // Open modal and set src when video column is clicked
    for (let i = 0; i < videoColumns.length; i++) {
        videoColumns[i].addEventListener("click", function() {

            // clear previous active video bar image
            activeVideoBarImage = videoBar.querySelector(".active");
            if (activeVideoBarImage) {
                activeVideoBarImage.classList.remove("active");
            }

            videoBarImages[i].classList.add("active");

            video.setAttribute("src", videoSrcs[i]);
            videoModal.classList.add("active");
            setTimeout(() => {
                video.play();
            }, 300);
        });
    }

    // Switch video src when clicking images on left side of modal
    for (let i = 0; i < videoBarImages.length; i++) {
        videoBarImages[i].addEventListener("click", function() {
            // clear previous active video bar image
            activeVideoBarImage = videoBar.querySelector(".active");
            if (activeVideoBarImage) {
                activeVideoBarImage.classList.remove("active");
            }

            video.classList.add("fade");
            video.pause();
            setTimeout(() => {
                video.setAttribute("src", videoSrcs[i]);
                video.classList.remove("fade");
                setTimeout(() => {
                    video.play();
                }, 150);  
            }, 150);

            for (let j = 0; j < videoBarImages.length; j++) {
                videoBarImages[j].classList.remove("active");
            }
            videoBarImages[i].classList.add("active");
        }); 
    }

    // Close modals on esc press or close button click
    document.onkeydown = function(evt) {
        evt = evt || window.event;
        if (evt.keyCode == 27) {
            videoModal.classList.remove("active");
            video.pause();
        }
    };
    videoClose.addEventListener("click", function() {
        videoModal.classList.remove("active");
        video.pause();
    });
    /* End Video Section */

    /* Second Panel Section */
    const secondPanelSection = document.querySelector(".second-panel-section");
    const svgs = secondPanelSection.querySelectorAll("svg");
    const imageDetailsContents = secondPanelSection.querySelectorAll(".image-details-content");

    for (let i = 0; i < svgs.length; i++) {
        
        svgs[i].addEventListener("click", function() {
            for (let j = 0; j < imageDetailsContents.length; j++) {
                imageDetailsContents[j].classList.remove("active");
            }
            imageDetailsContents[i].classList.add("active");
        }); 
    }
    /* End Second Panel Section */
}, false);